// extracted by mini-css-extract-plugin
export default {"root":"companiesTable_root__iMzf0","table":"companiesTable_table__usMxN","colorInherit":"companiesTable_colorInherit__p6BaC"};